export default __webpack_public_path__ + "static/media/Mode_Text.5fe574b2.svg";